module.exports = __webpack_public_path__ + "img/120.4eb6fe9f.jpg";